import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/LearningResourceTopicApi/" );

/* eslint-disable arrow-body-style */
/* eslint-disable object-shorthand */

/**
 * GET
 */

/**
 * Get global topics
 * @param {number} moduleId OPTIONAL: The module identification to query topics from
 */
export const listTopics = ( moduleId = null ) => {
  return instance.get( `ListTopics?moduleId=${moduleId}` );
};

/*
 * Get the content page url from Umbraco by it's linked database ID
 */
export const getTopicUrl = ( id, asAbsolute = false ) => {
  return instance.get( `GetTopicUrl?id=${id}&asAbsolute=${asAbsolute}` );
};

/**
 * Get user's topics
 * @param {number} moduleId OPTIONAL: The module identification to query topics from
 */
export const listUserTopics = ( moduleId = null ) => {
  return instance.get( `ListUserTopics?moduleId=${moduleId}` );
};

/**
 * Get topic status map
 */
export const GetTopicStatusCollection = () => {
  return instance.get( "GetTopicStatusCollection" );
};

/**
 * Gets a single topic
 * @param {number} id The identification of the topic to load
 */
export const loadTopic = ( id ) => {
  return instance.get( `LoadTopic?id=${id}` );
};

/**
 * Gets a user's single topic
 * @param {number} id The identification of the topic to load
 */
export const loadUserTopic = ( id ) => {
  return instance.get( `LoadUserTopic?id=${id}` );
};

/**
 * Gets the user's current status from the specified topic
 * @param {number} topicId The identification of the topic to acquire the status from
 */
export const getTopicUserStatus = ( topicId ) => {
  return instance.get( `GetTopicUserStatus?topicId=${topicId}` );
};

/*
 * Gets the CMS data for Topics from within Umbraco
 */
export const listCmsTopicData = () => {
  return instance.get( "ListCmsTopicData" );
};

/**
 * POST
 */

/**
 * Sets the user's current status in the specified topic
 * @param {number} topicId The identification of the topic to update
 * @param {string} status The status value to update
 */
export const setTopicUserStatus = ( topicId, status ) => {
  return instance.post( "SetTopicUserStatus", { topicId, status } );
};
